import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Pega aquí tu configuración real de Firebase
// AÑADIMOS "export" AQUÍ PARA QUE OTROS ARCHIVOS PUEDAN USARLA
export const firebaseConfig = typeof __firebase_config !== 'undefined' 
  ? JSON.parse(__firebase_config)
  : {
 apiKey: "AIzaSyBbClao8El1JvlIPljd3NUcn8HaSQKl8Qs",
  authDomain: "app-de-gestion-de-multas-c7d4d.firebaseapp.com",
  projectId: "app-de-gestion-de-multas-c7d4d",
  storageBucket: "app-de-gestion-de-multas-c7d4d.firebasestorage.app",
  messagingSenderId: "567082501092",
  appId: "1:567082501092:web:27420aa297ce09e3a43df1",
  measurementId: "G-K5SMGRRGME"
    };

// Inicializar Firebase
const app = initializeApp(firebaseConfig, "main");
export const db = getFirestore(app);
export const auth = getAuth(app);
export const appId = typeof __app_id !== 'undefined' ? __app_id : 'default-app-id';

// Centralizamos la configuración de roles aquí para que sea accesible en toda la app
export const rolesConfig = {
    admin: { name: 'Administrador', permissions: ['dashboard', 'registrar', 'buscar', 'pagar', 'reportes', 'infracciones', 'usuarios'] },
    inspector: { name: 'Fiscalizador', permissions: ['dashboard', 'registrar', 'buscar'] },
    cajero: { name: 'Cajero', permissions: ['dashboard', 'buscar', 'pagar'] },
    propietario: { name: 'Dueño de Establecimiento', permissions: ['dashboard', 'buscar'] }
};
